import { Link } from '@tanstack/react-router';
import { LucideIcon } from 'lucide-react';

type SettingsNavItemProps = {
  to: string;
  icon: LucideIcon;
  label: string;
  description: string;
};

export function SettingsNavItem({
  to,
  icon: Icon,
  label,
  description,
}: SettingsNavItemProps) {
  return (
    <Link
      to={to}
      activeOptions={{ exact: false, includeSearch: false }}
      activeProps={{
        className:
          'flex flex-1 justify-center items-center gap-3 px-3.5 py-2 rounded-2xl shadow-sm transition-colors bg-alba-blue-500 text-alba-white-500 lg:flex-none lg:justify-start',
      }}
      inactiveProps={{
        className:
          'flex flex-1 justify-center items-center gap-3 px-3.5 py-2 rounded-2xl shadow-sm transition-colors bg-transparent text-alba-black-500 hover:bg-alba-gray-200 lg:flex-none lg:justify-start',
      }}
    >
      {({ isActive }) => (
        <>
          <Icon className='h-4 w-4 shrink-0' strokeWidth={1.6} />
          <div className='flex flex-col gap-1 min-w-0'>
            {/* `whitespace-nowrap` abaixo de lg: ali a navegação é uma faixa
                horizontal e o rótulo truncado ("Gerenci…") não identifica a
                seção. Deixar transbordar para o scroll da faixa é melhor que
                cortar a palavra. */}
            <p className='text-xs font-normal leading-none whitespace-nowrap lg:truncate lg:whitespace-normal'>
              {label}
            </p>
            {/* A descrição é auxiliar: no empilhado ela cabe, na faixa
                horizontal só empurra o rótulo para o corte. */}
            <p
              className={`hidden text-[10px] font-normal lg:line-clamp-1 lg:block ${
                isActive ? 'text-[#e9d4ff]' : 'text-alba-gray-600'
              }`}
            >
              {description}
            </p>
          </div>
        </>
      )}
    </Link>
  );
}
